<template>
    <v-server-table :url="url ? url : route('actions.table')" :columns="columns" :options="options" class="trigger" ref="table">
        <template slot="name" slot-scope="props">
            <router-link :to="{ name: 'admin.trajectory_projects.trajectories.milestones.actions.view', params: {
                projectId: props?.row.milestone.trajectory.trajectory_project_id,
                trajectoryId: props?.row.milestone.trajectory_id,
                milestoneId: props?.row.milestone_id,
                id: props.row.id,
             }}">{{ props.row.name }}</router-link>
        </template>
        <template slot="depends_on" slot-scope="props">
            {{ uLang('app.' + props?.row.depends_on_type ?? '') }}
        </template>
        <template slot="assigned_role" slot-scope="props">
            <b-badge pill variant="primary">
                {{ props.row.assigned_to_role ? props.row.assigned_to_role.name : uLang('app.no_role') }}
            </b-badge>
        </template>
        <template slot="selling_price" slot-scope="props">
            <span v-if="props.row.selling_price_type === '€'" pill variant="primary">&euro;{{ props.row.selling_price_amount }}</span>
            <span v-if="props.row.selling_price_type === '%'" pill variant="primary">{{ props.row.selling_price_amount }}&#37;</span>
        </template>
        <template slot="purchase_price" slot-scope="props">
            <span v-if="props.row.purchase_price_type === '€'" pill variant="primary">&euro;{{ props.row.purchase_price_amount }}</span>
            <span v-if="props.row.purchase_price_type === '%'" pill variant="primary">{{ props.row.purchase_price_amount }}&#37;</span>
        </template>
        <template slot="filter__assigned_role">
            <multi-select :options="roles" :loading="!roles" :deselectLabel="uLang('app.press_enter_to_remove')"
                          :selectLabel="uLang('app.press_enter_to_select')" :selectedLabel="uLang('app.select')"
                          label="name" :placeholder="uLang('app.select_an_option')" @input="searchRole" track-by="name"/>
        </template>
        <template slot="filter__depends_on">
            <multi-select :options="dependencies" :loading="!dependencies" :deselectLabel="uLang('app.press_enter_to_remove')"
                          :selectLabel="uLang('app.press_enter_to_select')" :selectedLabel="uLang('app.select')"
                          label="name" :placeholder="uLang('app.select_an_option')" @input="searchDependsOn" track-by="id"/>
        </template>
    </v-server-table>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'
    import MultiSelect from 'vue-multiselect/src/index'

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        components: {
            'multi-select': MultiSelect,
        },

        props: {
            url: {
                type: String,
                required: false,
                default: null,
            },
            trajectoryProject: {
                required: true,
            },
            trajectory: {
                required: true,
            },
            milestone: {
                required: true,
            },
        },

        data () {
            return {
                roles: [],
                dependencies: [],
                columns: [
                    'name',
                    'depends_on',
                    'lead_time_in_days',
                    'assigned_role',
                    'selling_price',
                    'purchase_price',
                    'actions',
                ],
                filterable: [
                    'name',
                    // 'depends_on',
                    'lead_time_in_days',
                    // 'assigned_role',
                    'selling_price',
                    'purchase_price',
                ],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        depends_on: uLang('app.depends_on'),
                        lead_time_in_days: uLang('app.lead_time_in_days'),
                        assigned_role: uLang('app.assigned_to_role'),
                        selling_price: uLang('app.selling_price'),
                        purchase_price: uLang('app.purchase_price'),
                        actions: this.uLang('app.actions'),
                    },
                    customFilters: [
                        'assigned_role',
                        'depends_on',
                    ],
                },
            }
        },

        created() {
            this.retrieveRoles();
            this.retrieveDependsOn();
        },

        methods: {
            async retrieveRoles() {
                const {data} = await window.axios.get(route('roles.index'));
                this.roles = data;
            },

            async retrieveDependsOn() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.milestones.actions.index', {
                    trajectory_project: this.trajectoryProject.id,
                    trajectory: this.trajectory.id,
                    milestone: this.milestone.id,
                }));

                data.unshift(...[{id: 'start_of_trajectory', name: uLang('app.start_of_trajectory')},{id: 'approval_of_trajectory', name: uLang('app.approval_of_trajectory')}]);

                this.dependencies = data;
            },

            searchRole(role) {
                this.$refs.table.query.role = role !== null ? role.name : '';
                this.$refs.table.refresh();
            },

            searchDependsOn(dependency) {
                this.$refs.table.query.depends_on = dependency !== null ? dependency.id : '';
                this.$refs.table.refresh();
            },
        },
    }
</script>

<style lang="css" scoped>
</style>
